import React, { useMemo } from 'react';

import { Title } from 'components/Misc/Typography';

import Term from 'containers/Student/Exams/Profile/View/Connect/Term';
import Description from 'containers/Student/Exams/Profile/View/Connect/Description';

const Connect = ({ answers }) => {
	// Get all available connections
	const connections = useMemo(() => answers?.[0]?.connections || [], [answers]);

	return (
		<div className="space-y-4">
			{answers?.map(question =>
				<Term
					key={question?.id}
					question={question}
				/>
			)}

			<Title title="Izvēles variantu apraksti" />

			{connections?.map(connection =>
				<Description
					key={connection?.id}
					connection={connection}
				/>
			)}
		</div>
	);
};

export default Connect;